"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectRulesAgreementApi = void 0;
exports.createProjectRulesAgreementApi = (axios) => ({
    listProjectRulesAgreements() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/projectRulesAgreements')).data;
        });
    },
    getProjectRulesAgreementById(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/projectRulesAgreement/${props.projectRulesAgreementId}`)).data;
        });
    },
    createProjectRulesAgreement(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post('/projectRulesAgreements', props)).data;
        });
    },
    updateProjectRulesAgreement(_a) {
        var { projectRulesAgreementId } = _a, rest = __rest(_a, ["projectRulesAgreementId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/projectRulesAgreement/${projectRulesAgreementId}`, rest)).data;
        });
    },
    deleteProjectRulesAgreement(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/projectRulesAgreement/${props.projectRulesAgreementId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdFJ1bGVzQWdyZWVtZW50QXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9wcm9qZWN0UnVsZXNBZ3JlZW1lbnRBcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHYSxRQUFBLDhCQUE4QixHQUFHLENBQUMsS0FBb0IsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNqRSwwQkFBMEI7O1lBQzlCLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMseUJBQXlCLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUMzRCxDQUFDO0tBQUE7SUFFSyw0QkFBNEIsQ0FBQyxLQUVsQzs7WUFDQyxPQUFPLENBQ0wsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLDBCQUEwQixLQUFLLENBQUMsdUJBQXVCLEVBQUUsQ0FBQyxDQUMzRSxDQUFDLElBQUksQ0FBQztRQUNULENBQUM7S0FBQTtJQUVLLDJCQUEyQixDQUMvQixLQUdDOztZQUVELE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMseUJBQXlCLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDbkUsQ0FBQztLQUFBO0lBRUssMkJBQTJCLENBQUMsRUFVakM7WUFWaUMsRUFDaEMsdUJBQXVCLE9BU3hCLEVBUkksSUFBSSxjQUZ5QiwyQkFHakMsQ0FEUTs7WUFTUCxPQUFPLENBQ0wsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLDBCQUEwQix1QkFBdUIsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUMzRSxDQUFDLElBQUksQ0FBQzs7S0FDUjtJQUVLLDJCQUEyQixDQUFDLEtBRWpDOztZQUNDLE1BQU0sS0FBSyxDQUFDLE1BQU0sQ0FDaEIsMEJBQTBCLEtBQUssQ0FBQyx1QkFBdUIsRUFBRSxDQUMxRCxDQUFDO1FBQ0osQ0FBQztLQUFBO0NBQ0YsQ0FBQyxDQUFDIn0=